import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    row: {
      display: 'flex',
      alignItems: 'center',

      '& > * + *': {
        marginLeft: theme.spacing(1),
      },

      '& + div': {
        marginTop: theme.spacing(0.5),
      },
    },
    circle: {
      width: 16,
      height: 16,
      minWidth: 16,
      minHeight: 16,
      borderRadius: '50%',
      userSelect: 'none',
    },
    labelsContainer: {
      '& > * + *': {
        marginLeft: theme.spacing(1),
      },
    },
    label: {
      fontSize: theme.typography.pxToRem(13),
    },
    tooltipLabel: {
      maxWidth: 200,
      width: 200,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    disabled: {
      opacity: 0.5,
    },
    truncate: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  }),
);
